import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Colors, AnalyticsProps } from '@inplayer-org/inplayer-ui';

// components
import { PreviewBox, Image, Title, Button, Description, ContentWrapper, Backing } from './StyledElements';

const StyledPreviewBox = styled(PreviewBox)`
  height: 86%;
`;

const StyledImage = styled(Image)`
  margin-bottom: 0;
  position: relative;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  width: 60%;
  position: absolute;
  top: 20%;
  left: 13%;
`;

const StyledTitle = styled(Title)`
  background: ${Colors.lightGray};
  margin: 0;
`;

const StyledDescription = styled(Description)`
  background: ${Colors.lightGray};
`;

const StyledButton = styled(Button)`
  width: 100%;
  border-radius: 0;
  box-sizing: border-box;
  margin: 0 0 10px;
  height: 15px;
`;

interface OwnProps extends AnalyticsProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate4: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <StyledPreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <StyledImage isTemplateSelected={isTemplateSelected} />
      <StyledContentWrapper>
        <Backing>
          <StyledTitle />
        </Backing>
        <Backing>
          <StyledDescription />
          <StyledDescription />
          <StyledDescription />
        </Backing>
      </StyledContentWrapper>
      <StyledButton isTemplateSelected={isTemplateSelected} />
    </StyledPreviewBox>
  );
};

export default PreviewTemplate4;
